import { set, pageview } from 'react-ga';
import { LOCATION_CHANGE } from 'connected-react-router';

let currentPage = '';

export default () => next => (action) => {
    if (action.type === LOCATION_CHANGE) {
        const { payload: { location: { pathname, search } } } = action;
        const nextPage = `${pathname}${search}`;

        if (currentPage !== nextPage) {
            currentPage = nextPage;
            set({ page: nextPage });
            pageview(nextPage);
        }
    }

    return next(action);
};
